/**
 * REST test-report endpoints — Production Test Mode (factory QA).
 *
 *   POST /test-reports             — a `production_test` tester submits a run
 *   GET  /admin/test-reports       — admins list submitted runs (DOC4 AP-07)
 *
 * A test run exercises every function of a freshly built controller from the
 * mobile app's Test Mode. Each step is recorded with a pass/fail flag; the
 * overall `passed` verdict is true only when every step passed.
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
import { Iso8601Schema } from '../common/timestamp.js';
/** The controller kinds a tester can exercise (mirrors the mobile ProductKind). */
export const TestDeviceKindSchema = z.enum(['stair', 'ceiling', 'lift']);
/** One step in a test run (e.g. "Brightness 100%"). */
export const TestStepResultSchema = z.object({
    step: z.number().int().min(0),
    label: z.string().min(1).max(120),
    passed: z.boolean(),
});
// ── POST /test-reports ───────────────────────────────────────────────────────
export const TestReportCreateBody = z.object({
    /** Serial / testing key of the unit under test. */
    deviceSerial: z.string().min(1).max(120),
    deviceKind: TestDeviceKindSchema,
    /** Overall verdict — true only if every step passed. */
    passed: z.boolean(),
    results: z.array(TestStepResultSchema).min(1),
});
export const TestReportCreateResponse = z.object({
    id: UuidSchema,
    createdAt: Iso8601Schema,
});
// ── GET /admin/test-reports ─────────────────────────────────────────────────
export const TestReportSchema = z.object({
    id: UuidSchema,
    testerUserId: UuidSchema,
    testerMobile: z.string().min(1),
    deviceSerial: z.string().min(1),
    deviceKind: TestDeviceKindSchema,
    passed: z.boolean(),
    results: z.array(TestStepResultSchema),
    createdAt: Iso8601Schema,
});
export const TestReportListResponse = z.object({
    reports: z.array(TestReportSchema),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=test-reports.js.map